// Product image zoom/unzoom (prevent cart or menu button from being clicked when zoomed in on an image)
$('.pswp__button--close').on('pswpTap', function (event) {
    event.stopPropagation()
})

$(document).ready( function() {
    //videos
    var videos = $("video"); // Get the video element
    videos.each( function() {
        var video = $(this).get(0)
        if(video.autoplay) {
            $(this).attr('playsinline', '')
            video.play()
        } else {
            $(this).after('<div class="play-button"></div>')
        }
    })

    $('video').on("ended", function() {
        $(this).siblings('.play-button').show()
    });

    $(document).on('click', '.play-button', function() {
        $(this).siblings('video').get(0).play()
        $(this).hide()
    })

    $("video").click(function() {
        var video = $(this).get(0);
        if ( video.paused ) {
            video.play();
            $(this).siblings('.play-button').hide()
        } else {
            video.pause();
            $(this).siblings('.play-button').show()
        }
        return false;
    });

    //single realty open and close info table
    $('.single-realty .info-group > h3.label').click( function() {
        $(this).siblings('.info-table').slideToggle()
        if($(this).hasClass('closed')) {
            $(this).removeClass('closed')
        } else {
            $(this).addClass('closed')
        }
    })

    //popup list
    $('.popup-list-block .list-item .title').click( function() {
        $(this).siblings('.popup').show()
    })

    $('.popup .close-popup').click( function() {
        $(this).closest('.popup').hide()
    })

    $('.popup').click( function(e) {
        if( e.target === this ) {
            $(this).hide();
        }
    })
})